export default function Spinner({className})
{
  return <span className={`border-l-2 border-b-2 border-current rounded-full inline-block w-4 h-4 animate-spin ${className}`} />;
}
